import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";

import Requirements from "./Requirements";
import SingleUserRegistrationAndroid from "./SingleUserRegistrationAndroid";
import "./FrontPage.css";

class LandingPage extends Component {
  scrollTo = el => {
    switch (el) {
      case "registration":
        this.singleUserSection.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
        break;
      case "promo":
        this.promoSection.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
        break;
      default:
    }
  };

  render() {
    return (
      <div className="landing-page android">
        <div
          className="promo-content middark"
          ref={el => {
            this.promoSection = el;
          }}
        >
          <img src="/white-logo.png" width="200" />
          <div className="section middark">
            <div className="half-section">
              <p>
                Unfortunately we do not offer customer subscriptions for
                Pronounce Live anymore. If you are interested in having a
                school, please <a href="mailto:info@sanako.com">contact us</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage.js